import React, { Component } from 'react'

export default class Footer extends Component {
  render() {
    return (
      <footer>
         <p>&#169;2022  William Verga | Enjoy-Veg | All Rights Reserved</p>
      </footer>
    )
  }
}
